import {registerStyle, styleRule, StyleSheet, UI} from "../../../../stem-core/src/ui/UI.js";
import {ActiveButton} from "../../../../blinkpay/ui/Button.jsx";
import {InputLabel} from "../InputLabel.jsx";
import {BaseInputElement} from "../../../../stem-core/src/ui/input/BaseInputElement.js";


export class RadioButtonsInputStyle extends StyleSheet {
    @styleRule
    container = {
        display: "inline-block",
        margin: 8
    }

    @styleRule
    radioButtons = {
        display: "flex",
        width: "100%",
        ">:first-child": {
            marginLeft: 0,
            borderRadius: "4px 0 0 4px",
        },
        ">:last-child": {
            marginRight: 0,
            borderRadius: "0 4px 4px 0",
        },
    };

    @styleRule
    button = {
        padding: this.themeProps.RADIO_BUTTON_PADDING,
        flex: this.themeProps.RADIO_BUTTON_FLEX,
    };
}

@registerStyle(RadioButtonsInputStyle)
export class RadioButtonsInput extends BaseInputElement {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            initialValue: null,
            label: null
        };
    }

    renderActiveButtons() {
        const {styleSheet} = this;

        return this.options.values.map(value => (
            <ActiveButton
                label={value}
                active={value === this.getValue()}
                onClick={() => this.setValue(value)}
                className={styleSheet.button}
            />
        ));
    }

    render() {
        const {styleSheet} = this;
        const {label} = this.options;

        return [
            label && <InputLabel label={label} />,
            <div className={styleSheet.radioButtons}>
                {this.renderActiveButtons()}
            </div>
        ];
    }

    getActive() {
        return this.getValue();
    }
}